// extracted by mini-css-extract-plugin
export default {"body":"List_body__jzVSj","bodyRow":"List_bodyRow__onPIi"};